var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnpinned = function SvgUnpinned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.592 5.332h-1.62V19.21h1.62V5.332Z",
    fill: "#929294"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.782 20a.81.81 0 1 0 0-1.619.81.81 0 0 0 0 1.619Z",
    fill: "#929294"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.782 11.565A5.782 5.782 0 1 0 5.782 0a5.782 5.782 0 0 0 0 11.565Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.782 4.049c1.118 0 2.024-.518 2.024-1.157 0-.638-.906-1.156-2.024-1.156-1.117 0-2.023.518-2.023 1.156 0 .639.906 1.157 2.023 1.157Z",
    fill: "#fff"
  })));
};
export default SvgUnpinned;